<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.orderStatus === 'Y' ||
            formData.orderStatus === 'P' ||
            formData.orderStatus === 'C'
              ? 'success'
              : formData.orderStatus === 'S'
              ? 'warning'
              : formData.orderStatus === 'D' ||
                formData.orderStatus === 'R' ||
                formData.orderStatus === 'T'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_orderStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
          >
            <el-input v-model="formData.salesPersonName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
          >
            <el-input v-model="formData.bizPersonName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
          >
            <el-input v-model="formData.v_orderType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
          >
            <el-input v-model="formData.v_orderSource" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_issueType') || '下单方式'"
            prop="issueType"
          >
            <el-input v-model="formData.v_issueType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesSeason') || '销售季节'"
          >
            <el-input v-model="formData.v_salesSeason" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
          >
            <el-input v-model="formData.custName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custOrderNo') || '客户订单编号'"
          >
            <el-input v-model="formData.custOrderNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_form_label_identifyNo') || '识别单号'"
          >
            <el-input v-model="formData.identifyNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_customerComfirmTime') || '客户确认时间'
            "
          >
            <el-input v-model="formData.customerComfirmTime" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
          >
            <el-input v-model="formData.endCustName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
            <el-input v-model="formData.brandName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_brandDepartment') || '品牌方部门'
            "
          >
            <el-input v-model="formData.brandDepartment" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryDay') || '交货日期'"
          >
            <el-input v-model="formData.deliveryDay" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_shipmentType') || '出运方式'"
          >
            <el-input v-model="formData.v_shipmentType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryPort') || '交货港口'"
          >
            <el-input v-model="formData.v_deliveryPort" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryAddress') || '交货地址'"
          >
            <el-input v-model="formData.deliveryAddress" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_quotedMethod') || '报价方式'"
          >
            <el-input v-model="formData.v_quotedMethod" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_Total_order_cost') || '订单成本总价'
            "
          >
            <el-input v-model="formData.v_orderAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_currencyUnit') || '成本货币单位'"
          >
            <el-input v-model="formData.v_currencyUnit" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_Total_order_selling_price') ||
                '订单售价合计'
            "
          >
            <el-input v-model="formData.v_orderSalesAmount" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_salesCurrencyUnit') || '售价货币单位'
            "
          >
            <el-input
              v-model="formData.v_salesCurrencyUnit"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_paymentTerms') || '付款条件'"
          >
            <el-input readonly v-model="formData.v_paymentTerms"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_importanceLevel') || '订单性质'"
          >
            <el-input readonly v-model="formData.v_importanceLevel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderExecuteType') || '执行方式'"
          >
            <el-input readonly v-model="formData.v_orderExecuteType"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
          >
            <el-input v-model="formData.scmName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件'
            "
          >
            <el-input
              v-model="formData.v_factoryPaymentTerms"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
          >
            <el-input v-model="formData.orderScmCodeName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_settlementFactory') || '结算工厂'
            "
          >
            <el-input
              v-model="formData.settlementFactoryName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_exchangeRate') ||
                '下单汇率(1外币兑换人民币)'
            "
          >
            <el-input v-model="formData.exchangeRate" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_commissionRate') || '佣金比例(%)'
            "
          >
            <el-input v-model="formData.commissionRate" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_commissionAmount') || '实际佣金'"
          >
            <el-input v-model="formData.commissionAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_invoiceAmount') || '开票金额'"
          >
            <el-input v-model="formData.invoiceAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_importanceLevelDesc') || '订单性质说明'
            "
          >
            <el-input v-model="formData.importanceLevelDesc" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderRemark') || '订单备注说明'"
          >
            <el-input v-model="formData.orderRemark" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Submit：{{ formData.submitByName || '--' }} at
          {{ formData.submitTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName || '--' }} at
          {{ formData.reviewTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { orderCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.$api
        .orderInfoDetailApi({
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
